/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';

export function ZetaDataList(props) {
  const { id, options } = props;

  return (
    <datalist id={id}>
      {options &&
        options.map((t, i) => {
          return <option key={i}>{t}</option>;
        })}
    </datalist>
  );
}
